import { render, staticRenderFns } from "./SearchBrand.vue?vue&type=template&id=4a2d5266&"
import script from "./SearchBrand.vue?vue&type=script&lang=js&"
export * from "./SearchBrand.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports